export default {
  all: 'Qualquer',
}
